export default __webpack_public_path__ + "static/OgCard-908fa90639d24677a186c1178a9c3a44.png";